import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {CommonService} from './common.service';
import {LocalStorageService} from './local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public params = '';
    public headers = new HttpHeaders();
    public token;
    public user;

    constructor(public httpClient: HttpClient,
                private commonService: CommonService,
                public localStorage: LocalStorageService) {
        if (this.isAuthenticated()) {
            this.createTokenHeaders();
        }
    }

    getLoggedInUser() {
        return JSON.parse(this.localStorage.get('user'));
    }

    login(email: string, password: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.httpClient.post('account/login', {email, password}).subscribe((response: any) => {
                resolve({status: 200, object: response});
            }, error => resolve({status: error.status, message: error.message}));
        });
    }

    getRefreshToken(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.httpClient.get('account/refreshToken').subscribe((response: any) => {
                resolve({status: 200, object: response});
            }, error => resolve({status: error.status, message: error.message}));
        });
    }

    isAuthenticated() {
        if (this.localStorage.get('token')) {
            this.token = this.localStorage.get('token');
            return true;
        }

        return false;
    }


    createTokenHeaders() {
        const auth = 'Bearer ' + this.token;

        this.headers = this.headers.append('Authorization', auth);
    }

    async checkCode(authNumber: any, userId: number) {
        const securityNumber = `${authNumber.num1}${authNumber.num2}${authNumber.num3}${authNumber.num4}${authNumber.num5}${authNumber.num6}`;

        return new Promise((resolve, reject) => {
            this.httpClient.post('account/authStep', {securityNumber, userId}).subscribe(response => {
                resolve(response);
            }, error => reject(error.message));
        });
    }

    async office365StudentParentLogin(studentEmail: string, uniqueId: string, token: string) {
        return await this.commonService.postRequest('account/login/office365Student', {email: studentEmail, uniqueId, token})
    }

    logOut() {
        localStorage.clear();
    }
}
